import React, {Component} from 'react';
import {connect} from "react-redux";
import { lang } from '../../config/lang';
import * as UTILS from '../../config/utils';

class Contact extends Component {

    constructor(props)
    {
        super(props);
        this.state = {
        }

    }

    componentWillMount() { 
    }

    componentDidMount() {
    }
  
    componentWillUnmount() {
        
    }
  
    componentWillReceiveProps(newProps) {

    }

    componentDidUpdate() {
       
    }


  
    render() {
        return (
            <div className="container">
                {
                    (UTILS.stripTag(this.props.agency.others) !== '' && this.props.agency.others !== null) || 
                    (this.props.agency.phone !== '' && this.props.agency.phone !== null) ||
                    (this.props.agency.fax !== '' && this.props.agency.fax !== null) ||
                    (this.props.agency.email !== '' && this.props.agency.email !== null)  
                     ? <h4 className="mt-4 mb-4">{this.props.contactCaption}</h4> : ''
                }
                
                {
                    (UTILS.stripTag(this.props.agency.others) !== '' && this.props.agency.others !== null) ? 
                        <div className="row mb-2">
                            <div className="col-md-3">
                                <b><i className="fa fa-home"></i>{' ' + lang('address')}:</b>
                            </div>
                            <div className="col-md-9">
                                <span dangerouslySetInnerHTML={{__html: this.props.agency.others}}></span>
                            </div> 
                        </div> : '' 
                }

                {
                    (this.props.agency.phone !== '' && this.props.agency.phone !== null) ? 
                        <div className="row mb-2">
                            <div className="col-md-3">
                                <b><i className="fa fa-phone"></i>{' ' + lang('tel')}:</b>
                            </div>
                            <div className="col-md-9">
                                <span dangerouslySetInnerHTML={{__html: this.props.agency.phone}}></span>
                            </div> 
                        </div> : '' 
                }

                {
                    (this.props.agency.fax !== '' && this.props.agency.fax !== null) ? 
                        <div className="row mb-2">
                            <div className="col-md-3">
                                <b><i className="fa fa-fax"></i>{' ' + lang('fax')}:</b>
                            </div>
                            <div className="col-md-9">
                                <span dangerouslySetInnerHTML={{__html: this.props.agency.fax}}></span>
                            </div> 
                        </div> : '' 
                }

                {
                    (this.props.agency.email !== '' && this.props.agency.email !== null) ?               
                        <div className="row mb-2">
                            <div className="col-md-3">
                                <b><i className="icon-envelope"></i>{' ' + lang('email')}:</b>
                            </div>
                            <div className="col-md-9">
                                <span dangerouslySetInnerHTML={{__html: this.props.agency.email}}></span>
                            </div> 
                        </div> : '' 
                }

                {
                    (this.props.agency.homepage !== null && this.props.agency.homepage !== '') ?               
                        <div className="row mb-2">
                            <div className="col-md-3">
                                <b><i className="icon-link"></i>{' ' + lang('homepage')}:</b>
                            </div>
                            <div className="col-md-9">
                                <a href={ this.props.agency.homepage.indexOf('http://') === 0 || this.props.agency.homepage.indexOf('https://') === 0 ? this.props.agency.homepage : 'http://' + this.props.agency.homepage } dangerouslySetInnerHTML={{__html: this.props.agency.homepage}}></a>
                            </div>
                        </div> : '' 
                }

            </div>
        );
    }
}

function mapStateToProps(state) {
    return { 
        language: state.language
    };
}

export default connect(mapStateToProps)(Contact);